// extracted by mini-css-extract-plugin
export default {"wrapper":"Tooltip_wrapper__EWxr7","infoButton":"Tooltip_infoButton__XxS3l","tooltip":"Tooltip_tooltip__tagtx"};